import { Checkbox } from "@/components/ui/checkbox";
import { useLabels } from "@/hooks/use-labels";
import { useTodoLabels, useUpdateTodoLabels } from "@/hooks/use-todo-labels";

type LabelSelectorProps = {
  todoId: string;
};

/** TODO に紐付けるラベルを複数選択するチェックボックスリスト */
export const LabelSelector = ({ todoId }: LabelSelectorProps) => {
  const { data: labels, isLoading: isLabelsLoading } = useLabels();
  const { data: selectedIds, isLoading: isSelectedLoading } =
    useTodoLabels(todoId);
  const updateTodoLabels = useUpdateTodoLabels();

  const isLoading = isLabelsLoading || isSelectedLoading;

  if (isLoading) {
    return <div className="h-6 animate-pulse rounded bg-muted" />;
  }

  if (!labels || labels.length === 0) {
    return <p className="text-sm text-muted-foreground">ラベルがありません</p>;
  }

  const currentIds = selectedIds ?? [];

  const handleToggle = (labelId: string, checked: boolean) => {
    const nextIds = checked
      ? [...currentIds, labelId]
      : currentIds.filter((id) => id !== labelId);

    updateTodoLabels.mutate({ todoId, labelIds: nextIds });
  };

  return (
    <div className="flex flex-col gap-2">
      <span className="text-sm text-muted-foreground">ラベル</span>
      <div className="flex flex-wrap gap-3">
        {labels.map((label) => {
          const isChecked = currentIds.includes(label.id);
          return (
            <div key={label.id} className="flex items-center gap-2 text-sm">
              <Checkbox
                id={`label-${label.id}`}
                checked={isChecked}
                onCheckedChange={(checked) => handleToggle(label.id, checked)}
                aria-label={label.name}
              />
              <label htmlFor={`label-${label.id}`}>{label.name}</label>
            </div>
          );
        })}
      </div>
    </div>
  );
};
